import { configOption, KahunConfigurationOptionType } from "../lib/annotations";

export class ConversionTrackingOptions {
  @configOption({
    description: "Activate Google Tag",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  googleTagEnabled?: boolean;
  @configOption({
    description: "Google Tag script for conversion tracking",
    displayType: KahunConfigurationOptionType.Text,
  })
  customGoogleTag?: string;
  @configOption({
    description: "Activate Meta Pixel",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  metaPixelEnabled?: boolean;
  @configOption({
    description: "Meta Pixel (facebook) script for conversion tracking",
    displayType: KahunConfigurationOptionType.Text,
  })
  customMetaPixel?: string;
}